import React from 'react';
import { useSearchParams } from 'react-router-dom';
import Signin from './auth/Signin';

function Login() {
  const [searchParams] = useSearchParams();
  return <Signin eventCode={searchParams.get('event_code')} />;
}

export default Login;
